import { Component, Input, ViewEncapsulation } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { NavService, Menu } from "../../service/nav.service";
import { ParentService } from "src/app/services/parent.service";
import { ConfirmModalComponent } from "../confirm-modal/confirm-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "src/app/services/auth.service";
import { FormBuilder } from "@angular/forms";
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  parentData: any;
  public menuItems: Menu[];
  public url: any;
  public fileurl: any;
  userForm: any;
  deviceData: any;
  childName: any;
  constructor(
    private router: Router,
    public navServices: NavService,
    public auth: AuthService,
    public partentService: ParentService,
    private modalService: NgbModal,
    public fb: FormBuilder
  ) {
    this.navServices.items.subscribe((menuItems) => {
      this.menuItems = menuItems;
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter((items) => {
            if (items.path === event.url) this.setNavActive(items);
            if (!items.children) return false;
            items.children.filter((subItems) => {
              if (subItems.path === event.url) this.setNavActive(subItems);
              if (!subItems.children) return false;
              subItems.children.filter((subSubItems) => {
                if (subSubItems.path === event.url)
                  this.setNavActive(subSubItems);
              });
            });
          });
        }
      });
    });
  }
  async ngOnInit() {
    this.partentService.getParentDocData().subscribe((res) => {
      this.parentData = res;
    });

    this.userForm = this.fb.group({
      childid: [""],
      deviceid: [""],
      selectedDate: [""],
    });
    this.userForm.get("selectedDate").setValue(this.formatDate());

    this.userForm.valueChanges.subscribe((res: any) => {
      this.getChildName();
    });
    this.partentService.selectedParentChild.subscribe((res) => {
      this.userForm.patchValue(res);
      this.getChildName();
    });
  }
  // Active Nave state
  setNavActive(item) {
    this.menuItems.filter((menuItem) => {
      if (menuItem != item) menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true;
      if (menuItem.children) {
        menuItem.children.filter((submenuItems) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }
  collapseSidebar() {
    //  this.open = !this.open;
    var screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    }
  }
  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach((a) => {
        if (this.menuItems.includes(item)) a.active = false;
        if (!a.children) return false;
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0) return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    };
  }

  shareLink() {
    if (navigator.share) {
      navigator
        .share({
          title: "Swayam child365",
          text: "Check the apps your children are using, block harmful apps and know where you children are",
          url: "https://swayamapp.com/", // Replace with your actual share link
        })
        .then(() => {})
        .catch((error) => {});
    } else {
    }
  }

  openConfirm() {
    let message = "Do you want to logout?";
    let title = "Are you sure?";
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      size: "md",
      centered: true,
    });
    modalRef.componentInstance.text = message;
    modalRef.componentInstance.title = title;
    modalRef.result.then(
      (result) => {},
      (reason) => {
        if (reason == "yes") {
          this.auth.logout();
        } else {
        }
      }
    );
  }
  /*   goToPage(type: any) {
    const queryParams = { selectType: type };
    this.router.navigate(["/call-page"], { queryParams: queryParams });
    this.collapseSidebar();
  } */
  goToPage(type: any) {
    /*  const queryParams = { selectType: type };
     this.router.navigate([], { queryParams: queryParams }); */
    if (type == "sms") {
      this.router.navigate(["/call-page/sms/list"]);
    }
    if (type == "call") {
      this.router.navigate(["/call-page/contact"]);
    }
    if (type == "logs") {
      this.router.navigate(["/call-page/logs"]);
    }
    this.collapseSidebar();
  }
  getChildName() {
    this.partentService.getParentDocData().subscribe((res) => {
      this.childName = res.child_list[this.userForm.get("childid").value];
      console.log(this.childName);
    });
  }
  formatDate() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
}
